import React from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import Avatar from "../../../../components/Avatar";
import { createAvatarName } from "../../../../utils";
import { useUnassignedUsersAccordionState } from "../../hooks/useUnassignedUsersAccordionState";

const UnassignedUsersAccordion = React.memo(({
  unAssignedTeam,
  user,
  setUnassigned,
  searchQuery,
  openUnassigned,
  selectedUserIds,
  syncSelectedUsers,
}) => {
  const {
    areAllUnassignedSelected,
    handleAccordionChange,
    handleCheckboxClick,
    handleUserClick,
    selectedUserIdSet,
    shouldBeExpanded,
    tooltipTitle,
  } = useUnassignedUsersAccordionState({
    unAssignedTeam,
    user,
    setUnassigned,
    searchQuery,
    openUnassigned,
    selectedUserIds,
    syncSelectedUsers,
  });

  return (
    <Accordion
      expanded={shouldBeExpanded}
      onChange={handleAccordionChange}
      className="unassigned-accordion">
      <Tooltip 
        title={tooltipTitle}
        placement="top"
        arrow
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
          className="accordion-summary">
          <Box onClick={(event) => event.stopPropagation()}>
            <label className="custom-checkbox">
              <input
                type="checkbox"
                checked={areAllUnassignedSelected}
                onClick={handleCheckboxClick}
                onChange={() => {}}
              />
              <span className="checkmark"></span>
            </label>
          </Box>
          <Box className="team-name-box">
            <Typography>Unassigned Users</Typography>
          </Box>
        </AccordionSummary>
      </Tooltip>
      <AccordionDetails className="accordion-details">
        {unAssignedTeam.map((el, index) => (
          <CustomMenuItem
            key={`user-avtar-dropdown-admin-assign-${el.user_id}`}
            onClick={() => {
              handleUserClick(el);
            }}>
            <label className="custom-checkbox">
              <input
                type="checkbox"
                id={`user-check-box-${el.user_id}`}
                checked={selectedUserIdSet.has(String(el.user_id))}
                onClick={(event) => {
                  event.stopPropagation();
                }}
                onChange={()=>{}}
              />
              <span className="checkmark"></span>

              <Avatar
                key={`user-avtar-${el.user_id}`}
                username={`${el.first_name} ${el.last_name}`}
                user_image={el.user_image}
                title={`${el.first_name} ${el.last_name}`}
                className="user-avtar-dropdown user-avatar mr-8">
                {createAvatarName(`${el.first_name} ${el.last_name}`)}
              </Avatar>
              {`${el.first_name} ${el.last_name}`}
            </label>
          </CustomMenuItem>
        ))}
      </AccordionDetails>
    </Accordion>
  );
});

export default UnassignedUsersAccordion;
